<script>
export default {
  name: "Banner",

  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "mdi-information"
    },
    color: {
      type: String,
      default: "main"
    },
    dark: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<template>
  <div class="banner" :class="{ dark: dark }" :style="{ backgroundColor: `var(--v-${color}-base)` }">
    <v-icon>{{ icon }}</v-icon>
    <div class="banner-content">
      <span class="banner-title text-title">{{ title }}</span>
      <span class="banner-text">{{ text }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.banner {
  display: flex;
  gap: 10px;
  border-radius: 16px;
  padding: 20px;

  * {
    color: black;
  }

  &.dark * {
    color: var(--v-white-base);
  }

  .banner-content {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
}
</style>